export default __webpack_public_path__ + "static/indoor16-19677d520e6c70e69e5deee40b0e9abf.webp";